module.exports = __webpack_public_path__ + "static/media/default.1c8c76ae.jpg";